export class EnderecoInvestidor{
  instituicaoId: string;
  pais: string;
  endereco: string;
  complemento: string;
  cep: string;
  bairro: string;
  cidade: string;
  estado: string
}
